export default "__VITE_ASSET__3728809b__"